import * as React from "react";
const SvgButtonRetract = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	"xmlns:svgjs": "http://svgjs.com/svgjs",
	viewBox: "0 0 24 24",
	width: 24,
	height: 24,
	...props
}, /* @__PURE__ */ React.createElement("title", null, "Exported from Streamline App (https://app.streamlineicons.com)"), /* @__PURE__ */ React.createElement("g", { transform: "matrix(1,0,0,1,0,0)" }, /* @__PURE__ */ React.createElement("path", {
	d: "M 23.25,0.748l-6,6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 6.75,23.248v-6h-6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 17.25,0.748v6h6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 6.75,17.248l-6,6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 0.75,0.748l6,6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 17.25,23.248v-6h6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 6.75,0.748v6h-6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 17.25,17.248l6,6 ",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M 9,8.248h6c0.414,0,0.75,0.336,0.75,0.75v6c0,0.414-0.336,0.75-0.75,0.75H9 c-0.414,0-0.75-0.336-0.75-0.75v-6C8.25,8.584,8.586,8.248,9,8.248z",
	stroke: "#000000",
	fill: "none",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
})));
export { SvgButtonRetract as ReactComponent };
